import type { FC } from "react";

import { cn } from "@/ui/lib";
import {
  ITEM_DESCRIPTION_CLASS,
  TItemDescriptionProps,
} from "@/ui/components/data-display/Item/Item.config";

export const ItemDescription: FC<TItemDescriptionProps> = (
  {
    className,
    children,
    ...props
  },
) => (
  <p
    {...props}
    data-component="ItemDescription"
    className={cn(ITEM_DESCRIPTION_CLASS, className)}
  >
    { children }
  </p>
);

ItemDescription.displayName = "ItemDescription";
